import { ParkingSearchOptions } from "../Model/ParkList/ParkingSearchOptions";

export const parkingSearchOptionsMock : ParkingSearchOptions={
    checkIn: "2023-07-18T22:00:00.000Z",
    checkOut: "2023-07-23T22:00:00.000Z",
    destinationAirport: "Lotnisko Katowice",
    pageSize: 20,
    page: 1
}